<div class="center-xy" [ngStyle]="{'overflow': zones.overflow ? 'auto' : 'hidden'}"
    *ngIf="zones.selectedZone">
    <div class="zone-control-wrapper bg-light" data-testid="zone-control">
        <div class="zone-control__top">
            <div class="zone-control__top-icon bg-style bg-style__icon border-light">
                <zone-icon [name]="zones.selectedZone.description.styleIcon" [size]="45"></zone-icon>
            </div>
            <p class="zone-control__top-name font-bold font-24 bg-style bg-style__label color-light">
               {{ zones.getZoneName(zones.selectedZone) }}
            </p>
        </div>

        <div class="zone-control__content">
            <div class="zone-control__buttons-top">
                <div class="zone-control__close-button cursor-pointer bg-cancel bg-cancel__button"
                    data-testid="close-control"
                    (click)="zones.goHome()">
                    <img ngSrc="/assets/img/zone_icons/back_without_border.svg"
                        width="40" height="40" alt="" />
                </div>
            </div>

            <div class="zone-control__current-temp font-76">
                <p data-testid="current-temperature">
                    {{ zones.selectedZone['zone'].currentTemperature | format:7 }}
                </p>
            </div>

            <div class="zone-control__set-temp font-45 bg-settings bg-settings--zone font-bold">
                <p class="zone-control__set-temp-value" data-testid="set-temperature">
                   {{ zones.selectedZone['zone'].setTemperature | format:7 }}
                </p>
                <icon [iconName]="'schedule'"
                      data-testid="schedule-icon"
                      [iconSize]="54"
                      [className]="'zone-control__set-temp-img fill-set-temp-img'"
                      *ngIf="zones.selectedZone['mode'].mode == 'localSchedule'
                        || zones.selectedZone['mode'].mode == 'globalSchedule'">
                </icon>
                <icon [iconName]="'constant-temp'"
                      data-testid="constant-temp-icon"
                      [iconSize]="54"
                      [className]="'zone-control__set-temp-img fill-set-temp-img'"
                      *ngIf="zones.selectedZone['mode'].mode == 'constantTemp'">
                </icon>
                <icon [iconName]="'time-limit'"
                      data-testid="time-limit-icon"
                      [iconSize]="54"
                      [className]="'zone-control__set-temp-img fill-set-temp-img'"
                      *ngIf="zones.selectedZone['mode'].mode == 'timeLimit'">
                </icon>
                <p class="zone-control__time-limit font-20"
                   *ngIf="zones.selectedZone['mode'].mode == 'timeLimit'">
                   {{ zones.getTimeLimit(zones.selectedZone['mode'].constTempTime) }}</p>
            </div>

            <div class="zone-control__mode-select font-bold">
                <div class="zone-control__select"

                    (click)="zones.goToState('zone_constant_temperature');">
                    <div class="zone-control__select-icon"
                        [ngClass]="{ 'zone-control__select-icon--active': zones.selectedZone['mode'].mode === 'constantTemp'
                            || zones.selectedZone['mode'].mode === 'timeLimit' }">
                        <icon [iconName]="'constant-temp'"
                            data-testid="select-icon-active"
                            [iconSize]="80"
                            [className]="'zone-control__select-icon cursor-pointer zone-control__select-icon--white'">
                        </icon>
                        <icon [iconName]="'constant-temp'"
                              data-testid="select-icon"
                              [iconSize]="80"
                            [className]="'zone-control__select-icon cursor-pointer zone-control__select-icon--style fill-icon fill-icon--warning'">
                        </icon>
                        <div class="zone-control__controller-mode cursor-pointer"
                            *ngIf="zones.zonesParameter.value > 0"
                            (click)="$event.stopPropagation(); showAlertControllerMode()"></div>
                    </div>
                    <p>{{ subtitle(1660) }}</p>
                </div>

                <div class="zone-control__select"
                    (click)="zones.goToState('zone_schedule_select')">
                    <div class="zone-control__select-icon"
                        [ngClass]="{ 'zone-control__select-icon--active': zones.selectedZone['mode'].mode === 'localSchedule'
                            || zones.selectedZone['mode'].mode === 'globalSchedule' }">
                        <icon [iconName]="'schedule'"
                            data-testid="select-icon-active"
                            [iconSize]="80"
                            [className]="'zone-control__select-icon cursor-pointer zone-control__select-icon--white'">
                        </icon>
                        <icon [iconName]="'schedule'"
                            data-testid="select-icon"
                            [iconSize]="80"
                            [className]="'zone-control__select-icon cursor-pointer zone-control__select-icon--style fill-icon fill-icon--warning'">
                        </icon>
                        <div class="zone-control__controller-mode cursor-pointer"
                            *ngIf="zones.zonesParameter.value > 0"
                            (click)="$event.stopPropagation(); showAlertControllerMode()">
                        </div>
                    </div>
                    <p>{{ subtitle(293) }}</p>
                </div>

                <div class="zone-control__select zone-control__select--settings"
                    (click)="zones.goToState('zone_info');"
                    *ngIf="!(zones.selectedZone['actuators'].length == 0
                        && zones.selectedZone['zone'].signalStrength === null
                        && zones.selectedZone['zone'].batteryLevel === null
                        && zones.selectedZone['windowsSensors'].length == 0
                        && zones.selectedZone['additionalContacts'].length == 0
                        && !zones.selectedZone['underfloor'].id
                        && !zones.selectedZone['zone'].humidity)">
                    <div class="zone-control__select-icon">
                        <icon [iconName]="'settings'"
                            data-testid="select-icon-active"
                            [iconSize]="80"
                            [className]="'zone-control__select-icon cursor-pointer zone-control__select-icon--white'">
                        </icon>
                        <icon [iconName]="'settings'"
                            data-testid="select-icon"
                            [iconSize]="80"
                            [className]="'zone-control__select-icon cursor-pointer zone-control__select-icon--style fill-icon fill-icon--warning'">
                        </icon>
                    </div>
                    <p>{{ subtitle(3709) }}</p>
                </div>
            </div>
        </div>
    </div>
</div>
